<template>
    <div class="col-auto d-flex align-items-center" v-if="isLoading || navigationStore.loading || navigationStore.pricesLoading">
        <div class="spinner-border spinner-border-sm" role="status"></div>
    </div>
</template>

<script setup>
defineProps({
    isLoading: Boolean
})
const navigationStore = useNavigationStore();
</script>
